import React, { Component } from 'react';
import SelectorPage from './SelectorPage';
import PregnantPage from './PregnantPage';
import ParentPage from './ParentPage';
import GiftPage from './GiftPage';
import t from '../resources';
import Cookies from 'js-cookie';
import sendEvent from '../tracking';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import CookiesService from '../services/cookies';

class Intro extends Component {
    state = {
        opened: true,
        accepted: false,
        type: '',
        hide: false,
    };

    constructor(props) {
        super(props);
        this.modalContainer = React.createRef();
        this.state.opened =
            t('brendon.intro.cookie.link') !== window.location.pathname;
        this.state.hide = Cookies.get('is-cookies-accepted');
    }

    closeOnOverlay = (e) => {
        if (!this.modalContainer.current.contains(e.target)) {
            this.close(true);
        }
    };

    close = (overlay = false) => {
        if (this.state.accepted) {
            this.setState({
                opened: false,
            });
            sendEvent('intro', 'close', overlay ? 'overlay' : 'button');
        }
    };

    select = (type) => {
        sendEvent('intro', 'select', type);
        this.setState({
            type,
        });
    };

    acceptCookies = async () => {
        sendEvent('intro', 'acceptCookies');
        try {
            const response = await CookiesService.acceptCookies(
                this.props.acceptUrl,
            );
            if (response?.stored) {
                Cookies.set('is-cookies-accepted', true);
                this.setState({
                    accepted: true,
                });
            }
        } catch (error) {
            this.setState({
                opened: false,
            });
        }
    };

    componentDidMount = () => {
        this.acceptCookies();
    };

    render() {
        const { opened, type, accepted, hide } = this.state;
        if (hide || !opened) {
            return null;
        }
        return (
            <div
                className="position-fixed top left vw-100 vh-100 bg-transparent-dark zindex-9000"
                onClick={this.closeOnOverlay}
            >
                <div className="container h-100 d-flex align-items-center">
                    <div className="row flex-fill justify-content-center">
                        <div className="col-12 col-sm-10 col-lg-8 col-xl-6">
                            <div
                                className="min-h-350px bg-white rounded-lg shadow-lg position-relative d-flex flex-column"
                                ref={this.modalContainer}
                            >
                                {accepted && (
                                    <>
                                        {!type && (
                                            <SelectorPage
                                                onSelect={this.select}
                                            />
                                        )}
                                        {type === 'pregnant' && (
                                            <PregnantPage
                                                onClose={this.close}
                                            />
                                        )}
                                        {type === 'parent' && (
                                            <ParentPage onClose={this.close} />
                                        )}
                                        {type === 'gift' && (
                                            <GiftPage onClose={this.close} />
                                        )}
                                        <div
                                            className="position-absolute right top mt-2 mr-2 text-primary text-hover-blue-medium cursor-pointer d-flex line-height-3 align-items-center"
                                            onClick={this.close}
                                        >
                                            {!type && (
                                                <span className="font-size-0-75 text-uppercase mr-2">
                                                    {t('brendon.intro.close')}
                                                </span>
                                            )}
                                            <FontAwesomeIcon
                                                icon={faTimesCircle}
                                                className={`${
                                                    type
                                                        ? 'font-size-1'
                                                        : 'font-size-2'
                                                } line-height-3`}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Intro;
